import React from 'react';
import styled from 'styled-components'
import { colors } from '../style/colors';
import moment from 'moment'
import { navigate } from 'gatsby';
import Img from "gatsby-image"

const Container = styled.div`
    cursor: pointer;
    flex-basis: 50%;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    @media (max-width: 768px) {
    flex-basis: 100%;
    padding: 0;
    margin-bottom: 50px;

    }
`
const Cover = styled.div`
    height: 250px;
    width: 100%;
    position: relative;
    margin-bottom: 20px;

    @media (max-width: 768px) {
    height: 200px;

    }
`
const Title = styled.h1`
    color: ${colors.main};
    font-size: 32px;
	font-family: 'expo-serif-pro', serif;
`
const Date = styled.p``

const NewsItem = props => (
    <Container onClick={() => navigate(`/news/${props.slug}`)}>
        <Cover>
            <Img
                style={{
                    width: "100%",
                    height: "100%",
                    margin: 0,
                }}
                fadeIn
                objectFit="cover"
                fluid={props.fluid}
            />
        </Cover>

        <Title>{props.title}</Title>
        <Date>{moment(props.date).format("Do MMMM YYYY")}</Date>
    </Container>
)

export default NewsItem